interface Props {
  [key: string]: any
}

function FacebookIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 9 18" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={`${pathClassName ? `fill-current ${pathClassName} ` : ''}`}
        d="M2.43512 17.5676V9.32435H0.5V6.3564H2.43512V3.82138C2.43512 1.82934 3.57821 0 6.21212 0C7.27855 0 8.06713 0.115155 8.06713 0.115155L8.00499 2.88672C8.00499 2.88672 7.20077 2.8779 6.32317 2.8779C5.37334 2.8779 5.22116 3.37093 5.22116 4.18925V6.3564H8.08049L7.95608 9.32435H5.22116V17.5676H2.43512Z"
        fill="none"
      />
    </svg>
  )
}

export default FacebookIcon
